import RowStack from '@common-components/common/row-stack/RowStack';
import { getTaskSumByBoardIdRecord, selectCampaignNumberOfContactsByCampaignId, selectCampaignPendingMessageCountByCampaignId } from '@common-reducers/CampaignSelectors';
import { campaignsSelectOneObjectByQuery } from "@common-reducers/DBServiceThunks";
import { useAppSelector } from '@common-reducers/hooks/store.hook';
import TemplateRowDetails from './template-row-details';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';
import { namespace } from '@common-config/constants';

type Props = {
    campaignId: string;
    width: string;
    showSentProgress: boolean;
}

export default function CampaignInformation({ campaignId, width, showSentProgress }: Props) {
    const { t } = useTranslation(namespace);
    const campaign = useAppSelector(state => campaignsSelectOneObjectByQuery(state.DBCampaignReducer, {
        $or: [{ deleted: { $exists: false } }, { deleted: false }],
        _id: campaignId
    }));
    const numberOfContacts = useAppSelector(state => selectCampaignNumberOfContactsByCampaignId(state, campaign?._id))
    const numberOfSentMessages = useAppSelector(state => selectCampaignPendingMessageCountByCampaignId(state, campaign?._id))
    const taskSumByBoardIdRecord = useAppSelector(getTaskSumByBoardIdRecord);


    const totalNumberOfContacts = () => {
        if (campaign?.contactCount) {
            return campaign?.contactCount
        }
        else if (campaign?.list && campaign?.list?.contactIdList) {
            return campaign?.list?.contactIdList?.length
        }
        else {
            return (campaign?.boardIDArray?.reduce((sum, id) => sum + (taskSumByBoardIdRecord[id] ?? 0), 0) || 0)
        }
    };

    const formatISOCampaignCreationTime = (isoString: string | undefined) => {
        if (!isoString) return t('campaign.startTimeUnavailable');
        const date = new Date(isoString);
        const formattedDate = date.toLocaleDateString('en-GB');
        const formattedTime = date.toLocaleTimeString('en-GB', { hour12: false });
        return t('campaign.started', { date: formattedDate, time: formattedTime });
    };




    return (
        <div className={cn("h-full")} style={{ width }}>
            <RowStack className="mb-1.25">
                <span className="text-lg text-[var(--color-text)] dark:text-[var(--color-text)]">{campaign?.name}</span>
                <span className="text-xs font-semibold text-[#a6a6a6] dark:text-[#a6a6a6] mr-1.25">
                    {formatISOCampaignCreationTime(campaign?.schedule?.dueDate)}
                </span>
                <span style={{
                    //color: 'rgba(53, 190, 95, 0.75)',
                    color: 'var(--calendar-color-sage)',
                    fontWeight: 600,
                    fontSize: '12px'
                }}>
                    {isNaN(totalNumberOfContacts()) ? t('campaign.unknownContacts') : t('campaign.contacts', { count: totalNumberOfContacts() })}
                </span>
            </RowStack>

            {/* Template Details */}
            <TemplateRowDetails template={campaign?.template ?? {}} />
            {showSentProgress && numberOfContacts && (
                <span className="mt-1.25 text-[var(--color-text)] dark:text-[var(--color-text)]">
                    {numberOfSentMessages}/{numberOfContacts} {t('campaign.messagesSent')}
                </span>
            )}
        </div>
    );
}
